/**
 * Juno: open Calendly inline widget in a global modal (trigger: .js-open-calendly-vet-modal)
 */
(function () {
  var MODAL_ID = 'juno-calendly-vet-modal';
  var CALENDLY_SRC = 'https://assets.calendly.com/assets/external/widget.js';
  var pendingFallbackUrl = '';

  function getModal() {
    return document.getElementById(MODAL_ID);
  }

  function loadCalendlyScript() {
    return new Promise(function (resolve, reject) {
      if (window.Calendly) {
        resolve();
        return;
      }
      var existing = document.querySelector('script[data-juno-calendly-loader]');
      if (existing) {
        if (window.Calendly) {
          resolve();
          return;
        }
        existing.addEventListener('load', function () {
          resolve();
        });
        existing.addEventListener('error', reject);
        return;
      }
      var s = document.createElement('script');
      s.src = CALENDLY_SRC;
      s.async = true;
      s.dataset.junoCalendlyLoader = '1';
      s.onload = function () {
        resolve();
      };
      s.onerror = function () {
        reject(new Error('Calendly script failed'));
      };
      document.body.appendChild(s);
    });
  }

  var widgetInitialized = false;
  var previousFocus = null;
  var calendlyWarmStarted = false;

  function warmCalendlyScript() {
    if (calendlyWarmStarted || window.Calendly) return;
    if (document.querySelector('script[data-juno-calendly-loader]')) {
      calendlyWarmStarted = true;
      return;
    }
    calendlyWarmStarted = true;
    loadCalendlyScript().catch(function () {
      calendlyWarmStarted = false;
    });
  }

  document.addEventListener(
    'pointerover',
    function (e) {
      if (e.target && e.target.closest && e.target.closest('.js-open-calendly-vet-modal')) {
        warmCalendlyScript();
      }
    },
    true
  );

  document.addEventListener('focusin', function (e) {
    if (e.target && e.target.closest && e.target.closest('.js-open-calendly-vet-modal')) {
      warmCalendlyScript();
    }
  });

  function bindCalendlyEmbedReady(modal, stage) {
    if (!stage) return;
    var loading = stage.querySelector('.juno-calendly-vet-modal__embed-loading');
    var finished = false;
    var timeoutId = null;

    function cleanup() {
      if (finished) return;
      finished = true;
      window.removeEventListener('message', onMsg);
      if (timeoutId !== null) {
        clearTimeout(timeoutId);
      }
      stage.classList.add('is-calendly-ready');
      if (loading) {
        loading.setAttribute('aria-busy', 'false');
      }
    }

    function onMsg(e) {
      if (e.origin !== 'https://calendly.com') return;
      if (!e.data || typeof e.data !== 'object') return;
      var ev = e.data.event || '';
      if (typeof ev !== 'string' || ev.indexOf('calendly.') !== 0) return;
      cleanup();
    }

    window.addEventListener('message', onMsg);
    timeoutId = setTimeout(cleanup, 12000);
  }

  function syncCalendlyLoadingUi(modal) {
    var stage = modal.querySelector('.juno-calendly-vet-modal__embed-stage');
    if (!stage) return;
    var loading = stage.querySelector('.juno-calendly-vet-modal__embed-loading');
    if (widgetInitialized) {
      stage.classList.add('is-calendly-ready');
      if (loading) loading.setAttribute('aria-busy', 'false');
    } else {
      stage.classList.remove('is-calendly-ready');
      if (loading) loading.setAttribute('aria-busy', 'true');
    }
  }

  function initWidget(modal) {
    var host = modal.querySelector('[data-juno-calendly-inline-host]');
    if (!host || !window.Calendly || widgetInitialized) return;
    var stage = modal.querySelector('.juno-calendly-vet-modal__embed-stage');
    if (stage) {
      stage.classList.remove('is-calendly-ready');
      var loadingEl = stage.querySelector('.juno-calendly-vet-modal__embed-loading');
      if (loadingEl) loadingEl.setAttribute('aria-busy', 'true');
    }
    var url = host.getAttribute('data-calendly-url') || '';
    host.innerHTML = '';
    window.Calendly.initInlineWidget({
      url: url,
      parentElement: host,
      resize: true
    });
    widgetInitialized = true;
    bindCalendlyEmbedReady(modal, stage);
  }

  function openModal(fallbackUrl) {
    var modal = getModal();
    if (!modal) return;

    pendingFallbackUrl = fallbackUrl || '';

    previousFocus = document.activeElement;
    modal.classList.add('is-open');
    modal.setAttribute('aria-hidden', 'false');
    document.documentElement.style.overflow = 'hidden';
    document.body.style.overflow = 'hidden';

    syncCalendlyLoadingUi(modal);

    var closeBtn = modal.querySelector('.juno-calendly-vet-modal__close');
    if (closeBtn) closeBtn.focus();

    loadCalendlyScript()
      .then(function () {
        initWidget(modal);
        pendingFallbackUrl = '';
      })
      .catch(function () {
        if (pendingFallbackUrl) {
          window.open(pendingFallbackUrl, '_blank', 'noopener,noreferrer');
        }
        pendingFallbackUrl = '';
        closeModal();
      });
  }

  function closeModal() {
    var modal = getModal();
    if (!modal) return;

    modal.classList.remove('is-open');
    modal.setAttribute('aria-hidden', 'true');
    document.documentElement.style.overflow = '';
    document.body.style.overflow = '';

    pendingFallbackUrl = '';

    if (previousFocus && typeof previousFocus.focus === 'function') {
      previousFocus.focus();
    }
    previousFocus = null;
  }

  document.addEventListener('click', function (e) {
    var trigger = e.target.closest('.js-open-calendly-vet-modal');
    if (!trigger) return;
    e.preventDefault();
    openModal(trigger.getAttribute('href') || '');
  });

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    var modal = getModal();
    if (modal && modal.classList.contains('is-open')) {
      closeModal();
    }
  });

  function onDomReady(fn) {
    if (document.readyState === 'complete' || document.readyState === 'interactive') {
      fn();
    } else {
      document.addEventListener('DOMContentLoaded', fn);
    }
  }

  onDomReady(function () {
    var modal = getModal();
    if (!modal) return;

    modal.addEventListener('click', function (e) {
      if (e.target.closest('.js-calendly-vet-modal-close')) {
        closeModal();
      }
    });
  });
})();
